import React, { Component } from 'react';

import Paper from 'material-ui/Paper';

//import CourseAssignmentList from './components/CourseAssignmentList';
import CourseRelationController from './components/CourseRelationController';

function Attachment(props) {
  const attachment = props.attachment;
  if (attachment === null || attachment === undefined) {
    return null;
  }

  //const url = attachment.get('file').url();
  const relativePath = attachment.get('relativePath');
  const name = relativePath.match(/([^\/]*)\/*$/)[1];

  // const onDownload = function() {
  //   axios.get(url).then(res => {
  //     var binaryData = [];
  //     binaryData.push(res.buffer);

  //     var href = window.URL.createObjectURL(new Blob(binaryData, {type: 'application/zip'}));
  //     //var link = React.createElement('a', {href: href, download: name}, '');
  //     var link = document.createElement('a');
  //     link.href = href;
  //     link.setAttribute('download', name);
  //     link.click();    
  //   });
  // }

  const attachmentStyle = {
    border: '2px dashed rgba(230, 230, 230, .85)',
    borderRadius: '8px',
    fontSize: 'smaller',
    padding: '10px',
    display: 'table',
  };

  return (
    <p style={attachmentStyle} className='attachment-file'>{name}</p>    
  )
}

/*
function GradeDetail(props) {
  const { grade } = props;

  const className = grade == null ? 'grade' : 'grade grade--large';

  return (
    <Paper style={{margin: '5px 10px 10px 10px'}} zDepth={1}>
      <div className='course-detail-box__grade'>
        <p className='floating-label'>Grade</p>
        <p className={className}>
          {grade != null ? (
            grade.get('earnedPoints')
           ) : "None" }
        </p>
      </div>
    </Paper>
  );
}
*/

class CourseDetail extends Component {

  render() {
    const item = this.props.item;

    return (
      <div className="scene-main-content-box darker-background content-box-shadow scrollable-container">
        {item != null ? (
          <div className='course-detail-box'>
            <Paper style={{margin: '5px 10px 10px 10px'}} zDepth={1}>
              <div className='course-detail-box__metadata'>
                <h3 className='course-detail-box__metadata__title'>{item.get('title')}</h3>
                
                <div className='detail-item'>
                  <p className='floating-label'>Number</p>
                  <p className='detail-item__title'>{item.get('numberCode')}</p>
                </div>

                <div className='detail-item'>
                  <p className='floating-label'>Website</p>
                  { item.get('url') != null ? (
                    <a href={"http://" + item.get('url')} target="_blank">{item.get('url')}</a> 
                  ) : null }
                </div>

                <div className='detail-item'>
                  <p className='floating-label'>Syllabus</p>
                  <Attachment attachment={item.get('syllabus')} />
                </div>
              </div>
            </Paper>

            <CourseRelationController course={item} />
            
          </div>
        ) : (
          <div className="placeholder-container">
            <p>No Course Selected</p>
          </div> 
        )}
      </div>
    );
  }

}

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/scenes/Organizer/CourseDetail.js